import { ParameterType } from '@/study-search/enums';
import { DegreeTypeFilterOptionValue } from '@studyportals/search-filters/server-side';
import { TitleBase } from './TitleBase';

export default class TitleCountryAttendanceDegreeType extends TitleBase {
	private countryValue: string;
	private degreeTypeValue: string;
	private deliveryMethodValue: string;

	protected canHandle(): boolean {
		this.countryValue = this.getFilterValue(ParameterType.COUNTRY);
		this.degreeTypeValue = this.getFilterValue(ParameterType.DEGREE_TYPE);
		this.deliveryMethodValue = this.getFilterValue(ParameterType.DELIVERY_METHOD);

		return (
			this.indexableFilters.length === 3 &&
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY) &&
			this.indexableFilters.some((_) => _.type === ParameterType.DELIVERY_METHOD) &&
			this.indexableFilters.some((_) => _.type === ParameterType.DEGREE_TYPE && _.values[0] as DegreeTypeFilterOptionValue === DegreeTypeFilterOptionValue.MBA)
		);
	}

	protected getPageTitle(): string {
		return `${this.deliveryMethodValue} ${this.degreeTypeValue} in ${this.countryValue}`;
	}

	protected getMetaTitle(): string {
		const degreeTypeValue = this.getFilterMetaTitleValue(ParameterType.DEGREE_TYPE);

		return `${this.totalSearchResults} ${this.deliveryMethodValue} ${degreeTypeValue} in ${this.countryValue} | ${this.portalName}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(`${this.deliveryMethodValue} ${this.degreeTypeValue}`, ` in ${this.countryValue}`);
	}
}
